import { DDLOptions } from 'context/store/recommendationFormReducer';
import { isHungary } from './countryCode';

const traitOptionConstants = [
  {
    label: 'Clearfield®',
    value: 'IMI',
    disabled: false,
  },
  {
    label: 'Clearfield® Plus',
    value: 'IMI+',
    disabled: false,
  },
  {
    label: 'Clearfield® / Clearfield®Plus',
    value: 'IMI,IMI+',
    disabled: false,
  },
  {
    label: 'Sulfonylurea-tolerant',
    value: 'Sulfo',
    disabled: false,
  },
  {
    label: 'Conventional',
    value: 'Conventional',
    disabled: false,
  },
  {
    label: 'A.I.R.™',
    value: 'AIR',
    disabled: false,
  },
  {
    label: 'Express®',
    value: 'Express',
    disabled: false,
  },
];

export const clearfieldTraitValues = ['IMI', 'IMI+'];

export const getTraitOptions = (uniqueTraitValues: string[], countryCode: string | undefined) => {
  if (uniqueTraitValues.length > 0) {
    // remove AIR for HU
    const filteredValues = uniqueTraitValues.filter(
      (item) => item !== 'AIR' || !isHungary(countryCode)
    );
    const filterUniqueTraitValues = new Set(filteredValues);
    return traitOptionConstants.filter((item) => {
      const itemValues = item.value.split(',');
      return itemValues.some((v) => filterUniqueTraitValues.has(v));
    });
  }
  return [];
};

export const getTraitLabel = (value: any) => {
  const matchedValue = traitOptionConstants.find((item) => item.value === value);
  return matchedValue?.label ?? '';
};

// as we have merged Clearfield / Clearfield Plus, splitting the values before sending it to API
export const formatTraits = (traits: DDLOptions[]) => {
  const traitValues = traits.map((item: DDLOptions) => item.value);
  return traitValues.flatMap((t: string) => t.split(','));
};
